<template>
  <div style="background-color: #000" :class="isStaging3 ? 'isStaging3' : ''">
    <div class="first" v-if="init">
      <template v-if="isLargeScreen === true">
        <GCVideo autoplay preload="auto" :controls="false" @ended="init = false" @error="init = false" muted
          disablepictureinpicture disableremoteplayback :src="firstVideoUrl" />
      </template>
      <template v-else>
        <GCVideo :controls="false" x5-video-player-type="h5" webkit-playsinline="true" x-webkit-airplay="true"
          disablepictureinpicture disableremoteplayback playsinline="true" poster="" x5-playsinline
          class="firt-video-mobile" autoplay preload="auto" muted @ended="init = false" @error="init = false"
          :src="firstVideoUrl" />
      </template>
    </div>
    <Transition name="first">
      <div v-if="!init" class="container">
        <!-- 头图 -->
        <Header @toRule="handleToRule" :is-staging2="isStaging2" :is-staging3="isStaging3" />
        <!-- 活动时间 -->
        <ActivityTime class="limitWrapper" />
        <!-- 奖项设置 -->
        <PrizeSetting class="limitWrapper" :list="pageUI.rewards" :is-staging3="isStaging3" />
        <ActivityWorks class="limitWrapper" v-if="isStaging3" />
        <div class="content limitWrapper" :class="isStaging3 ? '' : 'bg'">
          <!-- 活动主题 -->
          <ActivityTheme v-if="!isStaging3" :topics="pageUI.topics" :is-staging2="isStaging2" />
          <!-- 参赛要求 -->
          <ActivityRequire v-if="!isStaging3" :rules="requireConfig" @toRule="handleToRule" />
          <!-- 活动评委 -->
          <ActivityJudges :is-staging3="isStaging3" :list="pageUI.reviewers" @toRule="handleToRule" />
        </div>
        <!-- 惊喜彩蛋 -->
        <ActivitySurprise class="limitWrapper" v-if="!isStaging3" />
        <!-- 参赛投稿 -->
        <ActivityPhotos class="limitWrapper" v-if="pageUI.showSubmitPage" />
        <!-- 版权声明 -->
        <CopyRight @toRule="handleToRule" />
      </div>
    </Transition>
    <BottomButton v-show="isStaging2 !== true && isInKwaiying() && !init && showBtn" />
  </div>
</template>
<script setup lang="ts">
import { ref, onMounted } from "vue";
import "vant/lib/index.css";
import ActivityTime from "~/components/kling/activity-time.vue";
import PrizeSetting from "~/components/kling/prize-setting.vue";
import ActivityTheme from "~/components/kling/activity-theme.vue";
import ActivityRequire from "~/components/kling/activity-require.vue";
import ActivityJudges from "~/components/kling/activity-judges.vue";
import ActivityPhotos from "~/components/kling/activity-photos.vue";
import ActivityWorks from '~/components/kling/activity-works.vue'
import Header from "~/components/kling/header.vue";
import useRem from "~/components/kling/common/useRem";
import { PageUI, getPageUI, getRewardList } from "~/components/kling/common/api/request";
import useDevice from "~/components/kling/common/useDevice";
import CopyRight from "~/components/kling/copy-right.vue";
import ActivitySurprise from "~/components/kling/activity-surprise.vue";
import kylogger from "@ky/sdk/dist/log/kylogger";
import isInKwaiying from "@ky/sdk/dist/isInKwaiying";
import BottomButton from "~/components/kling/bottom-button.vue";
import RaceModal from "./modal/raceModal.vue";
import CreateModal from "./modal/createModal.vue";
import callNative from "@ky/sdk/dist/callNative";
import canUseBridge from "@ky/sdk/dist/canUseBridge";
import open from "@ky/sdk/dist/open";
import GCVideo from "~/components/kling/common/GCVideo.vue";
import dayjs from "dayjs";
useRem();

const { isPC, isKs, isKyMobile } = useDevice();
const blackList = ["MQQBrowser", "micromessenger"].some(
  (it) => navigator.userAgent.toLowerCase()?.includes(it.toLocaleLowerCase()),
);

const route = useRoute();
const { query } = route;

/** 是否到第二阶段，征稿结束 */
const isStaging2 = dayjs().isAfter(dayjs('2024-08-04 23:59:59'));

const isStaging3 = ref(false);

const init = ref(!blackList);

const showBtn = ref(false);

// 路由跳转方法
const handleToRule = () => {
  const url = "https://" + window.location.host + `/kling/contribution/rules`;
  const ksUrl = "https://" + window.location.host + `/kling/contribution`;
  if (isInKwaiying()) {
    open(`kwaiying://web?url=${encodeURIComponent(url)}&showTopBar=false`);
  } else if (isKs.value) {
    open(`kwaiying://web?url=${encodeURIComponent(ksUrl)}&showTopBar=false`);
  } else {
    const path = `/kling/contribution/rules`;
    window.open(path, "_blank");
  }
};

const pageUI = ref<PageUI>({} as PageUI);

const firstVideoUrl = ref();

const isLargeScreen = ref();
const resize = () => {
  isLargeScreen.value = window.innerWidth >= 1360;
};
const handleScroll = () => {
  const scrollDistance = window.scrollY;
  if (scrollDistance > 400) {
    showBtn.value = true;
  } else {
    showBtn.value = false;
  }
};
onMounted(() => {
  resize();
  const params = JSON.stringify({ bounce: false });
  const IOS = /iP(hone|ad)/.test(navigator.userAgent);
  if (IOS) {
    window?.kwaiying && window?.kwaiying?.viewBounces?.(params);
    if (canUseBridge("setNavSwipe")) {
      callNative("setNavSwipe", {
        params: { canSwipe: false },
        isPromise: false,
      });
    }
  }


  if (query?.isStaging3Test !== undefined) {
    isStaging3.value = query.isStaging3Test?.toString() !== 'false' && query.isStaging3Test?.toString() !== '0';
    console.log('-----命中测试参数', isStaging3.value);
  } else {
    console.log('-----命中接口参数canShow');
    getRewardList().then((res) => {
      isStaging3.value = !!res?.data?.canShow;
      console.log('-----接口参数canShow为', isStaging3.value);
    }).catch(() => {
      isStaging3.value = false; // 接口请求失败还展示第二阶段页面
    })
  }
});
handleScroll();
window.addEventListener("resize", resize);
window.addEventListener("orientationchange", resize);
window.addEventListener("scroll", handleScroll);

onBeforeUnmount(() => {
  window.removeEventListener("resize", resize);
  window.removeEventListener("orientationchange", resize);
  window.removeEventListener("scroll", handleScroll);
})

watch(isLargeScreen, (value) => {
  if (value) {
    firstVideoUrl.value = `https://p4-ky.wsukwai.com/kos/nlav12119/DuFQTSEs_2024-07-03-17-02-21.mp4`;
  } else {
    firstVideoUrl.value = `https://p4-ky.wsukwai.com/kos/nlav12119/bHkTsucC_2024-07-04-16-47-08.mp4`;
  }
});

getPageUI().then((data) => {
  console.log(data);
  kylogger.sendImmediately("PV", "KELING_CREATE_ACTIVITY", {
    terminal: isInKwaiying() ? "ky" : "other",
  });
  pageUI.value = data.data;
});

// 要求
const requireConfig = computed(() => [
  {
    title: "01. 工具使用",
    titlePC: "工具使用",
    description:
      "参赛者须使用“可灵AI”生成视频素材、同时欢迎大家使用快影APP进行创作，以帮助您更便捷地发布快手作品",
  },
  {
    title: "02. 作品要求",
    titlePC: "作品要求",
    description:
      "视频素材由可灵AI生成制作，时长不低于30秒，建议不超过15分钟，画面比例不限，清晰度720p或以上",
  },
  {
    title: "03. 发布要求",
    titlePC: "发布要求",
    description: `在快手发布30秒以上的作品，并添加${pageUI.value?.topics
      ?.length}个话题标签：<span style="color: #4CA9FF">${pageUI.value?.topics?.join("、") || '#可灵AI #快影AI灵感迸发创作大赛 '}</span>
    发布后复制作品链接，在大赛活动页面内选择对应赛道，上传快手作品链接及作品简介完成投稿。“专家评审奖”每个赛道每人最多可投稿5个作品，“快手人气奖”投稿作品数不限。`,
  },
]);
</script>
<style lang="less">
:root {
  --safe-area-top: env(safe-area-inset-top);
  --safe-area-bottom: env(safe-area-inset-bottom);

  --van-toast-background: transparent ::-webkit-scrollbar {
    display: none;
  }
}

body {
  &::-webkit-scrollbar {
    display: none;
  }
}

.container {
  img {
    pointer-events: none;
  }
}
</style>
<style scoped lang="less">
.first {

  // position: fixed;
  // top: 0;
  // left: 0;
  // width: 100vw;
  // height: 100vh;
  // z-index: 1000;
  video {
    width: 100vw;
    height: 100vh;
    object-fit: cover;
  }
}

.first {

  &-enter-active,
  &-leave-active {
    transition: opacity 3s ease;
  }

  &-enter-from,
  &-leave-to {
    opacity: 0;
  }
}

.first-video-mobile {
  width: fit-content;
  height: 100vh;
}

.container {
  width: 100vw;
  min-height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;

  padding-bottom: var(--safe-area-bottom);

  background-color: #000;

  --kling-dark-bg-color: #000;
  --kling-light-bg-color: #000;

  .content {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    overflow: hidden;

    &.bg {
      background-position: 0 0;
      background-size: contain;
      background-repeat: no-repeat;
      background-image: url(https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/df430b45-6e36-49b7-b29f-46ef7af8b0a5.png);
    }

    @media screen and (max-width: 1360px) {
      background-image: none;
    }
  }

  .limitWrapper {
    max-width: 22.36rem;
  }
}
</style>
